import { Controller } from '@hotwired/stimulus';

export default class ModalController extends Controller {
  hide() {
    bootstrap.Modal.getInstance(this.element)?.hide();
  }
}
